/* Shared queue for explicit customer cart actions. Prices remain Shopify-authoritative. */
(() => {
  let queue = Promise.resolve();
  const root = () => window.Shopify?.routes?.root || '/';
  const api = window.IzuroCartActions = {
    async request(path, data) {
      const response = await fetch(root() + path, {credentials:'same-origin', headers:{Accept:'application/json', ...(data ? {'Content-Type':'application/json'} : {})}, ...(data ? {method:'POST', body:JSON.stringify(data)} : {})});
      const result = await response.json();
      if (!response.ok || result.status >= 400 || result.errors) throw new Error(result.description || 'Your bag could not be updated. Please try again.');
      return result;
    },
    codes(cart) {
      const codes = (cart.discount_codes || []).filter(c=>c.applicable !== false).map(c=>c.code);
      const discounts = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(i=>(i.line_level_discount_allocations || []).map(d=>d.discount_application))];
      discounts.filter(d=>d?.type === 'discount_code').forEach(d=>codes.push(d.title));
      return [...new Set(codes.filter(Boolean))];
    },
    money(cents, currency) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency || 'USD'}).format(cents / 100); },
    run(action) {
      const next = queue.catch(()=>{}).then(async()=>{
        await window.StudioCartRewards?.running;
        window.IzuroOfferBusy = true;
        try { return await action(); }
        finally { window.IzuroOfferBusy = false; window.StudioCartRewards?.schedule(); }
      });
      queue = next; return next;
    },
    async refresh(cart, trigger, open = false) {
      window.IzuroOfferBusy = false;
      if (window.StudioCartRewards) { await window.StudioCartRewards.render(); await window.StudioCartRewards.sync(); }
      document.querySelectorAll('izuro-cart-mirror').forEach(el=>el.refresh());
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'izuro-actions', sectionsRendered:true, cartData:cart});
      if (open) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.dataset.cartMode === 'drawer') drawer.open(trigger);
        else location.assign(root() + 'cart');
      }
    }
  };
  customElements.define('izuro-cart-mirror', class extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const source = document.querySelector('cart-drawer ' + this.dataset.source);
      if (!source) { this.replaceChildren(); return; }
      const clone = source.cloneNode(true);
      [clone, ...clone.querySelectorAll('*')].forEach(el=>{
        for (const attr of ['id','for','aria-controls','data-key']) if(el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).replaceAll('drawer','page').replaceAll('Drawer','Page'));
      });
      this.replaceChildren(clone);
    }
  });
  customElements.define('izuro-cart-protection', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', async event=>{
        event.stopPropagation(); const input = event.target; const checked = input.checked;
        input.disabled = true;
        try { await api.run(async()=>{
          let cart = await api.request('cart.js');
          const lines = cart.items.filter(i=>i.properties?._izuro_protection === 'true' && i.variant_id === Number(this.dataset.variant));
          if(checked&&!cart.items.some(i=>i.properties?._izuro_protection!=='true'&&i.properties?._studio_reward!=='gift'))throw new Error('Add a product before selecting shipping protection.');
          if (checked && !lines.length) await api.request('cart/add.js', {items:[{id:Number(this.dataset.variant), quantity:1, properties:{_izuro_protection:'true'}}]});
          if (!checked && lines.length) await api.request('cart/update.js', {updates:Object.fromEntries(lines.map(i=>[i.key,0]))});
          cart = await api.request('cart.js'); await api.refresh(cart);
        }); } catch(error) {
          try { const cart=await api.request('cart.js'); input.checked=cart.items.some(i=>i.properties?._izuro_protection==='true'&&i.variant_id===Number(this.dataset.variant)); }
          catch { input.checked=!checked; }
          this.querySelector('[data-protection-status]').textContent=error.message;
        }
        finally { input.disabled = false; }
      });
    }
  });
  document.addEventListener('shopify:section:select', event=>{
    if (event.target.querySelector('cart-drawer')) document.querySelector('cart-drawer')?.open();
  });
})();
